import {Injectable} from '@angular/core';
import {LOGIN_TYPE} from '../constants/login/login.type.constants';
import {StoreService} from '../modules/akita-mimic/services/store.service';
import {AppState} from '../modules/akita-mimic/models/store-states/app-state.model';

export const initialAppState = {
    toastDelayMS: 4000,
    currentVersion: '',
    isSearchAndTaskGlobalScope: true,
    isNotShowingSearchOnGoingBack: false,
    showSearchMenu: false,
    showDebugMenu: true,
    listViews: {},
    isShowingShortMenuSidebar: false,
    isShowingShortMenuContent: false,

    navigationHistory: [],
    isShowingHistoryOverlay: false,
    androidPermissions: false,
    maxImagesPerWorker: 10,
    preferences: {
        showBeginnersHelp: false,
    },
    hasActionButton: false,
    isInitialized: false,
    deleteVaultWithoutPrompt: false,
    disconnected: false,
    partnerId: null,
    connectionErrorTimeStamp: 0,
    lastLoginType: LOGIN_TYPE.NONE
};

@Injectable({ providedIn: 'root' })
export class AppStore extends StoreService<AppState> {

    public constructor() {
        super('app', initialAppState);
    }
}
